// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c412e09a","239":"9f05c4c2","455":"9f2af7c1","762":"fb9cf975"}[chunkId] + ".chunk.js";
};